import React from "react";
import { Helmet } from 'react-helmet';

import Nav from "../components/nav/Nav";
import HeroSection from "../components/hero_section/HeroSection";
import CTASection from "../components/cta/CTA";
import Footer from "../components/footer/Footer";

function BlogsPage() {
  const blogsData = [
    {
      title: "How to Change Username on Xiaohongshu (Rednote): A Beginner's Guide",
      description: "Step-by-step guide for TikTok users learning to use Xiaohongshu (Rednote) for the first time. Learn how to change your username, update your bio, and customize your profile effortlessly.",
      link: "/how-to-change-username-on-rednote",
    },
    {
      title: "Learn Chinese with TikTok's Viral Hit: Decoding 'Jin Sheng Yuan'",
      description: "Explore the world of Chinese culture and language through TikTok's viral hit, 'Jin Sheng Yuan.' Learn how to decode Chinese characters, understand Pinyin, and discover valuable insights from this popular content, helping you improve your Chinese language skills and immerse in Chinese media trends.",
      link: "/jin-sheng-yuan-tiktok-viral-song-chinese-lyrics",
    },
    {
      title: "Navigating XiaoHongShu Hashtags (Rednote): A Guide for English Speakers",
      description: "Learn how to find your community on Xiaohongshu (REDnote) as an English speaker. Use our Rednote hashtag finder tool to discover popular Chinese hashtags for beauty, gaming, books, cooking, and more.",
      link: "/rednote-hashtags-for-english-speakers",
    },
    {
        title: "Decode Rednote: Your Guide to the Top 100 Popular Slangs",
        description: "Discover the essential terms of Xiaohongshu (REDnote) to decode posts, leave engaging comments, and boost your interaction rate. Become a Xiaohongshu expert with XHSLingo.com.",
        link: "/rednote-hashtags-for-english-speakers",
    },
    {
        title: "XiaoHongShu for TikTok Users: A Quick Guide to Discovering XiaoHongShu",
        description: "A quick guide for TikTok users on how to use Xiaohongshu (Rednote) for social media, product discovery, and shopping inspiration.",
        link: "/rednote-hashtags-for-english-speakers",
    },
  ];

  const handleButtonClick = () => {
    console.log("Navigate to blog creation or subscription page.");
  };

  return (
    <div>
      <Helmet>
          <title>Discover Our Blogs - Tips and Insights on XiaoHongShu Lingo</title>
          <meta name="google-adsense-account" content="ca-pub-5419912423604609"></meta>
          <meta name="description" content="Stay updated with the latest tips, insights, and guides on XiaoHongShu (Rednote). Learn how to use the platform effectively and enhance your experience."/>
          <meta name="keywords" content="Xiaohongshu, Rednote, XiaoHongShu Lingo, Chinese hashtags, learn Chinese, TikTok guide, XiaoHongShu tips, XiaoHongShu blogs"/>
          <meta property="og:title" content="Discover Our Blogs - Tips and Insights on XiaoHongShu Lingo" />
          <meta property="og:description" content="Explore guides, tips, and insights on using XiaoHongShu (Rednote). Learn about hashtags, slangs, and more!"/>
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://xhslingo.com/blogs" />
          <meta property="og:image" content="https://xhslingo.com/logo512.png" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Discover Our Blogs - Tips and Insights on XiaoHongShu Lingo" />
          <meta name="twitter:description" content="Stay updated with the latest guides and tips on XiaoHongShu (Rednote). Learn how to enhance your platform experience."/>
          <meta name="twitter:image" content="https://xhslingo.com/logo512.png" />
          <link rel="canonical" href="https://xhslingo.com/blogs" />
      </Helmet>
      <Nav />
      <HeroSection
        title="Discover Our Blogs"
        subtitle="Stay Updated with the Latest Tips and Insights on XiaoHongShu Lingo"
        backgroundColor="bg-red-500"  // 可选传递其他颜色
        textColor="text-white"          // 可选传递其他文字颜色
      />
      <section className="bg-white py-16">
        <h2 className="text-3xl font-bold mb-8 text-center">Our Latest Blogs</h2>
        <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogsData.map((blog, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition"
            >
              <h3 className="text-xl font-semibold mb-4">{blog.title}</h3>
              <p className="text-gray-700 mb-4">{blog.description}</p>
              <a
                href={blog.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-500 underline"
              >
                Read More
              </a>
            </div>
          ))}
        </div>
      </section>
      <CTASection
        title="Want to Stay Updated?"
        description="Subscribe to our newsletter for the latest blogs and tips about Xiaohongshu."
        buttonText="Subscribe Now"
        onButtonClick={handleButtonClick}
      />
      <Footer />
    </div>
  );
}

export default BlogsPage;